import React from 'react';
import { IonSpinner } from '@ionic/react';
import { useAuthStore } from '../../store/useAuthStore';
import { useProfileStore } from '../../store/useProfileStore';

interface AuthGuardProps {
  children: React.ReactNode;
}

export const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuthStore();
  const { activeProfile } = useProfileStore();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-50">
        <IonSpinner name="crescent" />
      </div>
    );
  }

  if (isAuthenticated && !activeProfile) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-50 flex-col gap-4">
        <IonSpinner name="crescent" />
        <p className="text-gray-500 text-sm">Loading profile...</p>
      </div>
    );
  }

  return <>{children}</>;
};
